module.exports = __webpack_public_path__ + "img/chaumet-en-100.d5c8cab4.jpg";